import { render, staticRenderFns } from "./compLink.vue?vue&type=template&id=7ac5cfdc&scoped=true&"
import script from "./compLink.vue?vue&type=script&lang=js&"
export * from "./compLink.vue?vue&type=script&lang=js&"
import style0 from "./compLink.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./compLink.vue?vue&type=style&index=1&id=7ac5cfdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac5cfdc",
  null
  
)

export default component.exports